// Imperative canvas drawing for the live view, called once per frame from
// the driver rather than through React state: at ~30 frames a second a
// component re-render per frame is wasted work for what is a scrolling line.

import { VadParams } from "../shared/protocol"

// Resolved from daisyUI's CSS variables so the threshold lines match the
// accents the arm cards use in whatever theme is active. The fallbacks cover
// a variable somehow missing.
function armColors(canvas: HTMLCanvasElement): string[] {
  const styles = getComputedStyle(canvas)
  return [
    styles.getPropertyValue("--color-info").trim() || "#818cf8",
    styles.getPropertyValue("--color-success").trim() || "#34d399",
  ]
}

const VISIBLE_FRAMES = 300

export function drawTrace(
  canvas: HTMLCanvasElement | null,
  trace: number[],
  thresholds: VadParams[]
) {
  if (!canvas) return
  const ctx = canvas.getContext("2d")
  if (!ctx) return
  const w = (canvas.width = canvas.clientWidth)
  const h = canvas.height

  ctx.clearRect(0, 0, w, h)

  const colors = armColors(canvas)
  thresholds.forEach((params, i) => {
    ctx.strokeStyle = colors[i % colors.length]!
    ctx.globalAlpha = 0.35
    ctx.setLineDash([3, 3])
    for (const t of [
      params.positiveSpeechThreshold,
      params.negativeSpeechThreshold,
    ]) {
      const y = h - t * h
      ctx.beginPath()
      ctx.moveTo(0, y)
      ctx.lineTo(w, y)
      ctx.stroke()
    }
  })
  ctx.setLineDash([])
  ctx.globalAlpha = 1

  const start = Math.max(0, trace.length - VISIBLE_FRAMES)
  const step = w / VISIBLE_FRAMES

  ctx.strokeStyle = "#e2e8f0"
  ctx.lineWidth = 1.5
  ctx.beginPath()
  for (let i = start; i < trace.length; i++) {
    const x = (i - start) * step
    const y = h - trace[i]! * h
    if (i === start) ctx.moveTo(x, y)
    else ctx.lineTo(x, y)
  }
  ctx.stroke()
}

export function drawOrb(
  orb: HTMLDivElement | null,
  halo: HTMLDivElement | null,
  prob: number
) {
  if (orb) orb.style.transform = `scale(${1 + prob * 0.9})`
  if (halo) {
    halo.style.transform = `scale(${0.7 + prob * 0.8})`
    halo.style.opacity = String(prob * 0.5)
  }
}
